import React, {Component} from 'react';
import './style.scss';

export class RwaTable extends Component {
  render() {
    const data = [
      {
        index: '1',
        name: 'Treasury',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản phải đòi quốc gia',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản phải đòi ngân hàng',
        isPrimaryRow: false,
      },

      {
        index: '2',
        name: 'Khối KHDN',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi doanh nghiệp - SME',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi doanh nghiệp - DN khác',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Mua lại khoản phải đòi doanh nghiệp',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản cấp tín dụng chuyên biệt',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản vỡ nợ',
        isPrimaryRow: false,
      },

      {
        index: '3',
        name: 'Khối KHCN',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản cho vay thế chấp nhà',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi bán lẻ quay vòng',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Khoản phải đòi bán lẻ khác',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Mua lại khoản phải thu bán lẻ',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Các khoản vỡ nợ',
        isPrimaryRow: false,
      },

      {
        index: '4',
        name: 'Khối',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Công cụ vốn chủ sở hữu',
        isPrimaryRow: false,
      },
      {
        index: '',
        name: 'Tài sản khác',
        isPrimaryRow: false,
      },

      {
        index: '',
        name: 'Tổng cộng',
        isPrimaryRow: true,
      },
    ];
    return (
      <div style={{width: '100%', overflow: 'auto'}}>
        <table className='table-hover table-striped RwaTable'>
          <thead>
            <tr>
              <th>STT</th>
              <th style={{minWidth: 364}}>Đối tượng KH</th>
              <th>Số lượng khách hàng</th>
              <th>Số lượng khoản vay</th>
              <th>
                Dư nợ nội bảng
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Dư nợ ngoại bảng
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Tỷ trọng dư nợ nội bảng + ngoại bảng
                <br />
                <span className='unit'>%</span>
              </th>
              <th>
                Tỷ lệ nợ xấu
                <br /> <span className='unit'>%</span>
              </th>
              <th>
                EL %
                <br />
                <span className='unit'>
                  %
                  <br />
                  PD x LGD
                </span>
              </th>
              <th>
                EL
                <br />
                <span className='unit'>
                  Triệu đồng
                  <br />
                  PD x LGD x EAD
                </span>
              </th>

              <th>
                Dự phòng lũy kế
                <br />
                <span className='unit'>Triệu đồng (Dự phòng chung + Dự phòng cụ thể)</span>
              </th>

              <th>
                EL -Dự phòng lũy kế
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Hệ số rủi ro trung bình
                <br />
                <span className='unit'>
                  %<br /> (RWA/EAD)
                </span>
              </th>
              <th>
                Tài sản có rủi ro (RWA)
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>

              <th>
                Tỷ trọng RWA
                <br />
                <span className='unit'>%</span>
              </th>
              <th>
                Thu nhập lãi thuần
                <br />
                <span className='unit'>Triệu đồng</span>
              </th>
              <th>
                Thu nhập lãi thuần/RWA
                <br />
                <span className='unit'>%</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.file_name} className={item.isPrimaryRow && 'primaryRow'}>
                <td>{item.index}</td>
                <td>{item.name}</td>
                <td></td>
                <td></td>
                <td></td>

                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default RwaTable;



// WEBPACK FOOTER //
// src/pages/Raroc/Report/RWA/RwaTable.js